<template>
    <div class="wh100">
        <!--<img src="../../assets/img/adminIndex.png" style="width:100%;height:100%;"/>-->
    </div>
</template>
<script>

    export default {
        components: {},
        props: {},
        data() {
            return {
                
            };
        },
        methods: {
            
        },
        computed: {},
        mounted() { },
        created() {},
        watch: {},
    };
</script>
<style>
</style>